import { defineNuxtPlugin } from 'nuxt/app'
import { v4 as uuidv4 } from 'uuid'
import { getCookie, setCookie } from '~/utility/cookies'

const USER_SESSION_COOKIE = 'user_session_id'
const USER_SESSION_STORAGE_KEY = 'user_session_id'

export default defineNuxtPlugin(() => {
  let sessionId = getCookie(USER_SESSION_COOKIE)

  // If no cookie, try localStorage as fallback
  if (!sessionId) {
    sessionId = localStorage.getItem(USER_SESSION_STORAGE_KEY)
  }

  // Generate new session ID if none exists
  if (!sessionId) {
    sessionId = uuidv4()
  }

  // Set the cookie normally without protection
  setCookie(USER_SESSION_COOKIE, sessionId, 1) // 1 day expiry

  // Store in localStorage as additional backup
  try {
    localStorage.setItem(USER_SESSION_STORAGE_KEY, sessionId)
  } catch (e) {
    console.warn('localStorage not available for session backup')
  }

  return {
    provide: {
      sessionId,
    },
  }
})

// Type augmentation for Nuxt 3
declare module 'nuxt/app' {
  interface NuxtApp {
    $sessionId: string
  }
}
